import React from 'react'
import useFeatureFlag from 'app/ducks/featureFlags/hooks'
import { NEW_LIST_PAGE_FLAG } from './newListPageFlag'

/**
 * Renders `next` (the `ModelListPage` version of a list) while the
 * `new_list_page` flag is on for the user, `legacy` otherwise. Other props
 * are passed to whichever renders.
 */
const NewListPageSwitch = ({ next: Next, legacy: Legacy, ...props }) =>
  useFeatureFlag(NEW_LIST_PAGE_FLAG) ? (
    <Next {...props} />
  ) : (
    <Legacy {...props} />
  )

export default NewListPageSwitch
